import './SettingsSyncToCal.scss'
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../providers/Profile';
import { Link } from "react-router-dom";

export default function SettingsNoData() {
    const { t } = useTranslation();
    const profileContext = useProfile();
    const profileData = profileContext?.profile?.results;
    const [hrefData, setHrefData] = useState("");

    useEffect(() => {
        setHrefData(`mailto:myaccess@aircanada.ca?&subject=Sync to Calendar / Settings API failure (error 400)&body=Hello Team,%20%0D%0AName is ${profileData?.['name']} Emp id is ${profileData?.EmployeeId}, Base Location is ${profileData?.baseLocation} and Equipment is ${profileData?.equipment}`);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className='settings-sync-cal__cntr'>
            <div className='settings-sync-cal__header'>
                <div className='settings-sync-cal__title-cntr'>
                    <p className='settings-sync-cal__header-title'>{t('settingsScreen.header')}</p>
                    <p className='settings-sync-cal__header-how-to-sync'><Link to="/how-to-sync-cal" target='_blank' className="settings-sync-cal__header-how-to-sync-link">{t('settingsScreen.howToSync')}</Link></p>
                </div>
            </div>
            <div className='settings-no-data__notification'>
                <div className='settings-no-data__notification-warning'>
                    <i className='icon-circle-flight' />
                    <div>
                        <p>{t('settingsScreen.settingsScreenNoDataIssue1')}</p>
                        <p title="myaccess@aircanada.ca">{t('settingsScreen.settingsScreenNoDataIssue2')}
                            <span className='settings-no-data__system-error'>
                                <a className='settings-no-data__system-error-content' href={hrefData}>{t('settingsScreen.settingsNoDataSupportLink')}</a>
                            </span>
                        </p>
                    </div>
                    <div className="settings-no-data__reset-cntr" onClick={() => window.location.reload()}>
                        <span className="settings-no-data__reset-button">{t("settingsScreen.refresh")}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

